import React from "react";

import ActionButton from "../../Buttons/ActionButton";
import { useQzTrayCertificate } from "../../../hooks/qztray/useQzTrayCertificate";

const QzTrayCertificateGeneratorActions: React.FC = () => {
  const {
    form,
    isSubmitting,
    generateCertificate,
    clearGenerateCertificateForm,
  } = useQzTrayCertificate();

  const handleGenerate = () => {
    generateCertificate({
      commonName: form.commonName,
      organization: form.organization,
      organizationalUnit: form.organizationalUnit,
      countryCode: form.countryCode,
      validYears: form.validYears,
      dnsNames: form.dnsNames,
      ipAddresses: form.ipAddresses,
    });
  };

  return (
    <div className="flex flex-col gap-3 border-t border-stroke pt-6 dark:border-strokedark sm:flex-row sm:justify-end">
      <ActionButton
        label="Limpiar"
        variant="secondary"
        size="md"
        fullWidth={false}
        disabled={isSubmitting}
        onClick={clearGenerateCertificateForm}
      />

      <ActionButton
        label={isSubmitting ? "Generando..." : "Generar Certificado"}
        variant="primary"
        size="md"
        fullWidth={false}
        disabled={isSubmitting}
        onClick={handleGenerate}
      />
    </div>
  );
};

export default QzTrayCertificateGeneratorActions;